import { render } from "./Sponsorlist.vue?vue&type=template&id=4a2ac8dc&ts=true"
import script from "./Sponsorlist.vue?vue&type=script&lang=ts"
export * from "./Sponsorlist.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__